import dayjs from 'dayjs'

import { getLesson, isWindowLesson, WINDOW_CLASS_TYPE_ID } from '../../schedule/utils/lessonHelpers'

export { getLesson, isWindowLesson, WINDOW_CLASS_TYPE_ID }

export function isWindowClassType(classTypeId) {
    if (classTypeId === undefined || classTypeId === null || classTypeId === '') return true

    return Number(classTypeId) === WINDOW_CLASS_TYPE_ID
}
export { getSubjectName } from '../../schedule/utils/lessonHelpers'

export function getClassId(item, lesson) {
    return lesson?.class_id || item?.class_id
}

export function getLessonGroupIds(item, lesson) {
    const raw = lesson?.group_id ?? item?.group_id ?? item?.group?.group_id

    if (Array.isArray(raw)) {
        return raw.map((g) => Number(g)).filter((g) => !Number.isNaN(g))
    }

    if (raw === undefined || raw === null || raw === '') return []

    const num = Number(raw)
    return Number.isNaN(num) ? [] : [num]
}

export function getLessonSubjectId(item, lesson) {
    return lesson?.subject_id || item?.subject_id || item?.subject?.subject_id || ''
}

export function getLessonTeacherId(item, lesson) {
    return lesson?.teacher_id || item?.teacher_id || item?.teacher?.teacher_id || ''
}

export function getLessonRoomId(item, lesson) {
    return lesson?.room_id || item?.room_id || item?.room?.room_id || ''
}

export function getLessonBuildingId(item, lesson) {
    return (
        lesson?.building_id
        || item?.building_id
        || item?.room?.building_id
        || lesson?.room?.building_id
        || ''
    )
}

export function getLessonClassTypeId(item, lesson) {
    return (
        lesson?.class_type_id
        || item?.class_type_id
        || item?.class_type?.class_type_id
        || ''
    )
}

export function getLessonClassTypeName(item, lesson) {
    return lesson?.class_type?.name || item?.class_type?.name || '-'
}

export function getGroupName(item, lesson) {
    return item?.group?.name || item?.group_name || lesson?.group_name || '-'
}

export function getGroupsDisplayName(item, lesson, groups) {
    const raw = lesson?.group_id ?? item?.group_id ?? item?.group?.group_id

    if (Array.isArray(raw) && raw.length > 0) {
        const names = raw.map((id) => {
            const found = groups.find((g) => String(g.group_id) === String(id))
            return found?.name || id
        })
        return names.join(', ')
    }

    return getGroupName(item, lesson)
}

export function changeDateFormat(date) {
    if (!date) return ''
    const parsed = dayjs(date, ['YYYY-MM-DD', 'DD.MM.YYYY'], true)
    return parsed.isValid() ? parsed.format('YYYY-MM-DD') : ''
}

export function getTodayValue() {
    return new Date().toISOString().slice(0, 10)
}

export function buildEditFormFromLesson({
    item,
    lesson,
    viewMode,
    selectedGroupId,
    selectedTeacherId,
    emptyForm,
}) {
    const isWindow = isWindowLesson(item, lesson)

    if (isWindow) {
        return {
            ...emptyForm,
            class_date: lesson?.class_date || item?.class_date || '',
            bell_id: lesson?.bell_id || item?.bell_id || '',
            group_id:
                viewMode === 'group'
                    ? selectedGroupId
                        ? [Number(selectedGroupId)]
                        : getLessonGroupIds(item, lesson)
                    : [],
            teacher_id:
                viewMode === 'teacher'
                    ? selectedTeacherId
                        ? Number(selectedTeacherId)
                        : ''
                    : '',
        }
    }

    return {
        class_date: lesson?.class_date || item?.class_date || '',
        bell_id: lesson?.bell_id || item?.bell_id || '',
        group_id: getLessonGroupIds(item, lesson),
        subject_id: getLessonSubjectId(item, lesson),
        teacher_id: getLessonTeacherId(item, lesson),
        building_id: getLessonBuildingId(item, lesson),
        room_id: getLessonRoomId(item, lesson),
        class_type_id: getLessonClassTypeId(item, lesson),
        class_type_name: getLessonClassTypeName(item, lesson),
    }
}

export function buildNewLessonForm({
    emptyForm,
    selectedGroupId,
    selectedTeacherId,
    defaultBellId,
}) {
    return {
        ...emptyForm,
        class_date: getTodayValue(),
        bell_id: defaultBellId || '',
        group_id: selectedGroupId ? [Number(selectedGroupId)] : [],
        teacher_id: selectedTeacherId ? Number(selectedTeacherId) : '',
        building_id: '',
        room_id: '',
    }
}
